// driversStore.ts (or .js)
import { create } from 'zustand';

// Each driver's payload exactly as your websocket sends it:
export type DriverHOS = Record<string, string>;

type Store = {
  byId: Record<string, DriverHOS>;
  // Replace or create driver entry with the new payload (as-is)
  upsertDriver: (driverId: string, data: DriverHOS) => void;
  // Merge a few fields
  patchDriver: (driverId: string, patch: Record<string, string>) => void;
};

export const useDriversStore = create<Store>((set) => ({
  byId: {},
  upsertDriver: (driverId, data) =>
    set((s) => ({ byId: { ...s.byId, [driverId]: { ...data } } })),
  patchDriver: (driverId, patch) =>
    set((s) => {
      const prev = s.byId[driverId] ?? {};
      return { byId: { ...s.byId, [driverId]: { ...prev, ...patch } } };
    }),
}));
